<div class="sso-loading-overlay">
    <h2 class="title">Autenticando...</h2>
    <p class="message">Validando token e carregando perfil.</p>
    <small class="helper-text">Por favor, aguarde.</small>
</div>